import { ReactNode } from "react";
import { Container } from "react-bootstrap";

import Body from "../Body";
import Main from "../Main";
import Sidebar from "../Sidebar";
import Footer from "../Footer";

type LayoutProps = {
	header?: { exibirAplicativos?: boolean };
	sidebar?: boolean;
	children: ReactNode;
};

export default function Layout({ header, sidebar, children }: LayoutProps) {
	return (
		<Container fluid className="layout p-0" style={{ minHeight: "100vh" }}>
			<Body>
				<Sidebar collapse={sidebar} />
				<div className="d-flex flex-column flex-fill">
					<Main>{children}</Main>
					<Footer />
				</div>
			</Body>
		</Container>
	);
}
